import MetricsHelper from '@/helpers/metrics';
import types from './types';

export const state = {
  locations: [],
  coordinates: [],
  total: {
    visits: 0,
    cities: 0,
    countries: 0,
  },
  numberOfPages: 0,
  page: 1,
  pageIdentifier: 0,
};

export const mutations = {
  [types.LOCATIONS_SET_PAGE](state, data) {
    state.page = data;
  },
  [types.LOCATIONS_SET_LIST](state, data) {
    if (!data) {
      state.locations = [];
      state.total = { visits: 0, cities: 0, countries: 0 };
      return;
    }

    state.locations = data.locations;
    state.numberOfPages = data.total_pages;
    state.total = data.total;

    state.locations.forEach((location) => {
      location.visitsPercentage = MetricsHelper.percentage(location.visits, state.total.visits);
    });
  },
  [types.LOCATIONS_SET_COORDINATES](state, data) {
    state.coordinates = data;
  },
  [types.LOCATIONS_SET_PAGEIDENTIFER](state, pageIdentifier) {
    state.pageIdentifier = pageIdentifier;
  },
};



// WEBPACK FOOTER //
// ./src/screens/Locations/store/mutations.js